// removed by extract-text-webpack-plugin
module.exports = {"warp":"pages-MyAccount-Welcomeback-process-warp","title":"pages-MyAccount-Welcomeback-process-title","secordTitle":"pages-MyAccount-Welcomeback-process-secordTitle","descContent":"pages-MyAccount-Welcomeback-process-descContent","form":"pages-MyAccount-Welcomeback-process-form","button":"pages-MyAccount-Welcomeback-process-button","buttoWarp":"pages-MyAccount-Welcomeback-process-buttoWarp","uploaderHr":"pages-MyAccount-Welcomeback-process-uploaderHr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/Welcomeback-process/WelcomeBackProcess.css
// module id = 1799
// module chunks = 0